var _index = -1,
	tempItem, pz, pzItems,
	filter_toggle_top = 0,
	prevButton = $("<div class='prevButton'></div>"),
	nextButton = $("<div class='nextButton'></div>");
prevButton.on("click", onPrev);
nextButton.on("click", onNext);
var cart_save_button = null;

$.validator.setDefaults({
	highlight: function(element) {
		$(element).closest('.form-group').addClass('has-error');
	},
	unhighlight: function(element) {
		$(element).closest('.form-group').removeClass('has-error');
	},
	errorElement: 'span',
	errorClass: 'help-block',
	errorPlacement: function(error, element) {
		if(element.parent('.input-group').length) {
			error.appendTo(element.parent().parent());
		} else {
			error.insertAfter(element);
		}
	}

	
});

$.validator.addMethod( "postcodeNL", function( value, element ) {
    return this.optional( element ) || /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test( value );
}, "Deze postcode is onjuist voor het gekozen land" );
$.validator.addMethod( "postcodeBE", function( value, element ) {
    return this.optional( element ) || /^[1-9][0-9]{3}/i.test( value );
}, "Deze postcode is onjuist voor het gekozen land" );

$(document).ready(function() {
	$.ajaxSetup({ cache: false });

    $("#usp-bar [data-toggle=popover]").popover();
    $("#rma-submit [data-toggle=popover]").popover();
    $("#shipinfo-popover [data-toggle=popover]").popover();

	$(document).on('click', '.hoesjes-submenu', function(e) {
		e.stopPropagation();
	});




	$('.dropdown-menu-functions a[data-toggle="collapse"]').click(function(e) {
		e.stopPropagation();
		e.preventDefault();
		// get the href of the link and only use the part after the # tag
		var href = $(this).prop('href').replace(/^.*#/, '');
		//console.log(href);
		var area_nav = $('#' + href);

		if (!area_nav.hasClass('in')) {
			//console.log(area_nav);
			area_nav.parent().find('.collapse').removeClass('in');
			area_nav.collapse('show');
		}


	});

	$('#hmenu-tel').on('show.bs.collapse', function () {
		//$('#hmenu-tel .collapse').removeClass('in');
	});


	$('select').wrap("<div class='select-wrapper'></div>");
	
	var cookiesset = $.cookie('kloegcom_cookies') != null;
	
	if (cookiesset)
	{
		$.cookie('kloegcom_cookies', 'true', {expires: 1000, path: '/'});
	} else
	{
		$(window).on('scroll', accepting_cookie);
	}

	$('#close-cookie').click(function(e) {
		e.preventDefault();
		accepting_cookie();
	});
	
	$('#show-touch-menu').click(function(e) {
		e.preventDefault();
		if ($('.filter-list').hasClass('touch-menu')) {
			$('#smartphone-menu, .filter-list').toggleClass('touch-menu');
		} else {
			$('html, body, #page, #smartphone-menu').toggleClass('touch-menu');
		}
	});
		
	$('#hide-touch-menu').click(function(e) {
		e.preventDefault();
		$('html, body, #page, #smartphone-menu').toggleClass('touch-menu');
	});

	$("#smartphone-menu").on("swipeleft",function(){
		$('html, body, #page, #smartphone-menu').toggleClass('touch-menu');
	});

	$('#mobile-filter-toggle').click(function(e) {
		e.preventDefault();
		if ($('#smartphone-menu').hasClass('touch-menu')) {
			$('#smartphone-menu, .filter-list').toggleClass('touch-menu');
		} else {
			$('html, body, #page, .filter-list').toggleClass('touch-menu');
		}
		//$('.is_stuck').toggleClass('hidden');
	});
	//$('header').stick_in_parent({ parent: 'body', bottoming: false});

	$('.desktop-filter').click(function(e) {
		e.preventDefault();
			$('html, body, #page, .filter-list').toggleClass('touch-menu');
		$('.filter-list').css('top', $('#static-header').height());
		//$('.is_stuck').toggleClass('hidden');
	});
	//$('header').stick_in_parent({ parent: 'body', bottoming: false});


	$('.mobile-toggle').click(function(e) {
		e.preventDefault();
		$($(this).data('toggle')).toggleClass('in');
	});

	$('#cat-sortby, #cat-sortby-ds').change(function() {
		window.location.href = updateQueryStringParameter(window.location.href, 'sortby',  $(this).val());
	});
	if ($('.filter-toggle').length > 0) {
		filter_toggle_top = $('.filter-toggle').offset().top - 15;
	}

	if (($('body').width() > 1700) && ($('.desktop-filter.btn-blue').length > 0)) {
		$('.desktop-filter.btn-blue').trigger('click');
	}

	function stickyMenu() {
		var windowTop = $(window).scrollTop(),
        	windowWidth = $(window).width(),
            windowHeight = $(window).height(),
		  footerTop = $('footer').offset().top;
		
        if (windowTop > windowHeight) {
            $('#to-top').addClass('fade in').removeClass('hide')
        } else {
        	$('#to-top').addClass('fade hide').removeClass('in');
        }
		if (!$('html').hasClass('touch-menu')) {
			if ((windowTop + $('header').height()) >= filter_toggle_top) {
				$('.filter-toggle').addClass('is_stuck');
				$('.filter-list').addClass('is_stuck');
			} else {
				$('.filter-toggle').removeClass('is_stuck');
				$('.filter-list').removeClass('is_stuck');
			}
		}

        if ((windowTop + windowHeight) > footerTop)
        {
	   	//$('.filter-toggle').hide();
	   } else
	   {
	   	//$('.filter-toggle').show();
	   }
	}

	$(window).on('scroll resize', stickyMenu);
	stickyMenu();

	$('#to-top').click(function(e) {
		e.preventDefault();
		$('body, html').animate({ scrollTop: '0px' });
	});
	
	$('#zoeken-ja').click(function(e) {
		e.preventDefault();
		var params = [];
		params.push({name: 'result', value: 'ja'});
		$.post(window.base_url + 'search.feedback.php', params, function(data) {
		});			
	});
	
	$('#zoeken-nee').click(function(e) {
		e.preventDefault();
		var params = [];
		params.push({name: 'result', value: 'nee'});
		$.post(window.base_url + 'search.feedback.php', params, function(data) {
			window.location.href = window.base_url + 'hulp-bij-zoeken';
		});			
	});
	
	$('.track-and-scroll').click(function(e) {
		e.preventDefault();
		var target = this.hash;
		var $target = $(target);
		var toppos = $target.offset().top - (($('header').hasClass('is_stuck')) ? 40 : 120);
	    $('html, body').stop().animate({
	        'scrollTop': toppos
	    }, 900);
		ga('send', 'event', 'click', $(this).data('trackaction'), $(this).data('tracklabel'), parseInt($(this).data('trackvalue')));
	});

	if (window.location.hash.length > 0) {
		var target = window.location.hash.substring(1);

		var $target = $('a[name="' + target + '"]');
		var topbody = $('body').css('marginTop').replace('px', '');
		var toppos = $target.offset().top - parseInt(topbody);
		console.log(toppos);
		$('html, body').stop().animate({
			'scrollTop': toppos
		}, 900);

	}

	$("body").fitVids();
	
	$(document).bind("contextmenu",function(e){
        if(e.target.nodeName == 'IMG'){
            //context menu attempt on top of an image element
            return false;
        }
    });
	
	$('.fade-xs-toggle').click(function(e) {
		e.preventDefault();
		$(this).parent().prev('.fade-xs').addClass('in');
		$(this).hide();
	});
	
	$('.toggle-button a').click(function(e) {
		e.preventDefault();
		var toggle_elm = $(this).data('toggle');
		$(toggle_elm).toggleClass('in');
	});
	
	$('#searchsubmit').click(function(e) {
		e.preventDefault();
		$('#search').submit();
	});
	$('#filter-merk').change(function(e) {
		if ($(this).find('option:selected').data('merk-id'))
		{
			var merk_id = $(this).find('option:selected').data('merk-id');
			var categorie_id = $('#filter-base').data('categorie-id');
			$.post(window.base_url + 'lists/modellen', {merk_id: merk_id, categorie_id: categorie_id}, function(data) {
				if (data.succes)
				{
						var filter_html = '<option value="">kies een model</option>';
					    var shopname = '';
						$.each(data.modellen, function(key, model) {
							if (shopname != model.shop) 
							{
								if (shopname.length > 0) filter_html = filter_html + '</optgroup>';
								filter_html = filter_html + '<optgroup label="' + model.shop + '">';
								shopname = model.shop;
							}
							filter_html = filter_html + '<option value="' + model.urlnaam + '" data-model-id="' + model.id + '">' + model.model + '</option>';
						});
					$('#filter-model').html(filter_html);
				} else
				{
						$('#filter-model').html('<option value="">kies eerst een merk</option>');
				}
			}, 'json');
		} else
		{
				
		}
	});
	
	$('#filter-model').change(function(e) {
		if ($(this).find('option:selected').data('model-id'))
		{
			//alert($('#filter-base').val() + '/' + $('#filter-merk').val() + '/' + $('#filter-model').val());
			window.location.href = $('#filter-base').val() + '/' + $('#filter-merk').val() + '/' + $('#filter-model').val();
		} else
		{
				
		}
	});
	
	$('.click-box').click(function() {
		window.location.href = $(this).find('a').prop('href');
	});
	
	$('#assortiment-filter-nav').click(function(e) {
		e.preventDefault();
		$('.nav-shops').toggleClass('in');
	});
	
	$('.dropdown-full').on('mouseenter', function (e) {
		$('.hoesjes-submenu a:first').tab('show');
	})
	
	$('.dropdown-full').on('focus', function (e) {
		$('.hoesjes-submenu a:first').tab('show');
	})
	
	$('.dropdown-full').on('show.bs.dropdown', function (e) {
		$('.hoesjes-submenu a:first').tab('show');
	})

	$('.dropdown-full').on('hide.bs.dropdown', function (e) {
		$('.hoesjes-submenu a:first').tab('show');
	})

	$('#product-modellen-view').click(function(e) {
		e.preventDefault();
		$('#product-modellen-list').toggleClass('in');
        if ($('#product-modellen-list').hasClass('in')) $(window).scrollTop($('#product-modellen-list').offset().top - 80);
	});

	$('.dummy-button').click(function(e) {
		e.preventDefault();
	});
	
	$('.list-group-toggle-more').click(function(e) {
		e.preventDefault();
		$(this).next('.collapse').addClass('in');
		$(this).addClass('hidden');
	});
	$('.list-group-toggle-less').click(function(e) {
		e.preventDefault();
		$(this).parent('.collapse').removeClass('in');
		$(this).parent().prev('.list-group-toggle-more').removeClass('hidden');
	});
	
	$('.cms-content img').addClass('img-responsive');
	
	/* PRODUCT DETAIL PAGE */	
	$('#product-thumbs').flexslider({
		animation: "slide",
		controlNav: false,
		animationLoop: false,
		slideshow: false,
		itemWidth: 130,
		itemMargin: 15,
		asNavFor: '#product-foto'
	  });
	$('#product-foto').flexslider({
		animation: "slide",
		controlNav: false,

		animationLoop: false,
		slideshow: false,
		sync: "#product-thumbs"
	});


	$('#product-foto .slides img').click(function(e) {
		e.preventDefault();
		var val = $(this).data('index');
		setIndex(val);
	});

	$('#product-foto .slides img').on('gesturestart', function(e) {
		e.preventDefault();
		$(this).trigger('click');
	})

	if ($('#product-foto').length == 1)
	{
		tempItem = $("[data-elem='tempItem']");
		pz = new PinchZoomer(tempItem);
        pzItems = $('#pzItems img');

        pzItems.detach();
    }

	$('#model_id').change(function () {
		if (typeof $(this).find('option:selected').data('infourl') !== 'undefined')
		{
			window.location.href = window.base_url + $(this).find('option:selected').data('infourl');
			return;
		}
	});

	// was #product-cart-id
	$('select[name=product_id]').change(function() {
		if (typeof $(this).find('option:selected').data('infourl') !== 'undefined')
		{
			window.location.href = window.base_url + $(this).find('option:selected').data('infourl');
			return;
		}
		if ($(this).find('option:selected').data('foto') > 0)
		{
			$('#product-thumbs li').eq($(this).find('option:selected').data('foto') - 1).trigger('click');
		}
        if ($(this).find('option:selected').data('switch') == 1)
		{
			window.location.href = window.base_url + $(this).find('option:selected').data('url');
			return;
		}
		if ($(this).find('option:selected').data('status') == 'uitverkocht') {
			$('.cart-button').addClass('hidden');
            $('#form-uitverkocht').removeClass('hidden');
            $('.vink-list li').eq(0).addClass('uitverkocht').removeClass('voorraad').html('<b>Uitverkocht</b>');
            $('.vink-list li').eq(1).addClass('hidden');
            $('.vink-list li').eq(2).addClass('hidden');
        } else {
            $('.cart-button').removeClass('hidden');
            $('#form-uitverkocht').addClass('hidden');
            $('.vink-list li').eq(0).removeClass('uitverkocht').addClass('voorraad').html('<b>Op voorraad</b>');
            $('.vink-list li').eq(1).removeClass('hidden');
            $('.vink-list li').eq(2).removeClass('hidden');
		}



	});
	
	$('#product-cart-add').click(function(e) {
		e.preventDefault();
		$('#product-cart-form').submit();
	});
	
	$('#product-cart-form').validate({
		submitHandler: function(form) {
			var cart_data = $(form).serializeArray();
			cart_data.push({name: 'view_prod_id', value: $('#product-cart-add').data('view-prod-id')});
			if (typeof fbq != 'undefined') {
				fbq('track', 'AddToCart', {
					content_ids: [$('#product-cart-id option:selected').prop('value')],
					content_type: 'product',
					value: $('#product-cart-id').data('prijs'),
					currency: 'EUR'
				});
			}
			$.post(window.base_url + 'cart.addsingle.php', cart_data, function(data) {
					if (data.success)
					{
						$('.cart-count').html(data.cart.aantal);
						$('.cart-price').html('&euro; ' + prijs(data.cart.prijs));
						winkelwagen_succes();
					} else
					{
						if (data.message)
						{
							winkelwagen_error(data.message);
						}
						if (data.reset)
						{
							window.location.href = window.location.href;
						}
					}				
			}, 'json');
		}
	});
	
	$('.product-mp-add').click(function(e) {
		e.preventDefault();
		$(this).closest('.product-mp-form').submit();
	});
	
	$('.product-mp-form').each(function() {
		$(this).validate({
			submitHandler: function(form) {
				var cart_data = $(form).serializeArray();
				cart_data.push({name: 'view_prod_id', value: $(form).find('.product-mp-add').data('view-prod-id')});
				cart_data.push({name: 'meerprijs_id', value: $(form).find('.product-mp-add').data('mp-id')});
				$.post(window.base_url + 'cart.addmultiple.php', cart_data, function(data) {
					if (data.success)
					{
						$('.cart-count').html(data.cart.aantal);
						$('.cart-price').html('&euro; ' + prijs(data.cart.prijs) );
						winkelwagen_succes();
					} else
					{
						if (data.message)
						{
							winkelwagen_error(data.message);
						}
                        if (data.reset)
                        {
                            window.location.href = window.location.href;
                        }
					}
				}, 'json');
			}
		});
	});

    $('#product-alts').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 292,
        itemMargin: 0
    });

    $('#form-uitverkocht').validate({
        submitHandler: function(form) {
            var uitverkocht_form = $(form).serializeArray();
            uitverkocht_form.push( { name: 'prod_id', value: $('#product-cart-id option:selected').data('prod') } )
            $.post(window.base_url + 'mailing.uitverkocht.php', uitverkocht_form, function(data) {
                if (data.success)
                {
                    messagebox(BootstrapDialog.TYPE_SUCCESS, 'Notificatie toevoegoed', 'Zodra dit product weer op voorraad is ontvang u een bericht.');
                } else
                {
                    messagebox(BootstrapDialog.TYPE_DANGER, 'Helaas', 'Het is niet gelukt een notificatie te plaatsen.');
                }
            }, 'json');
        }
	});

    /* BESTELLEN OVERZICHT PAGE */
	$('select[name=cadeau]').change(function() {
		var line = $(this).closest('.line').data('line-code');
		var cart_data = [];
		cart_data.push({name: 'line', value: line});
		cart_data.push({name: 'cadeau', value: $(this).val()});
		$.post(window.base_url + 'cart.cadeau.php', cart_data, function(data) {
			if (data.success)
			{
				$('.cart-count').html(data.cart.aantal);
				$('.cart-price').html('&euro; ' + prijs(data.cart.prijs));
				update_carttotal(data.cart);
				update_cartline(data.line);
			} else
			{
				if (data.message)
				{
					winkelwagen_error(data.message);
				}
			}
		}, 'json');
	});

	$('input[name=line_count]').on('keyup change', function(e) {
		if ((e.which > 48 && e.which < 58) || (e.type == 'change'))
		{
			var line = $(this).closest('.line').data('line-code');
			var cart_data = [];
			cart_data.push({name: 'line', value: line});
			cart_data.push({name: 'aantal', value: $(this).val()});
			$.post(window.base_url + 'cart.update.php', cart_data, function(data) {
				if (data.success)
				{
					$('.cart-count').html(data.cart.aantal);
					$('.cart-price').html('&euro; ' + prijs(data.cart.prijs) );
					update_carttotal(data.cart);
					update_cartline(data.line);
				} else
				{
					if (data.message)
					{
						winkelwagen_error(data.message);
					}
				}
			}, 'json');
		}
	});

	$('.line-delete').click(function(e) {
		e.preventDefault();
		var line = $(this).closest('.line').data('line-code');
		var cart_data = [];
		cart_data.push({name: 'line', value: line});
		$.post(window.base_url + 'cart.delete.php', cart_data, function(data) {
			if (data.success)
			{
				window.location.href = window.base_url + 'bestellen';
			} else
			{
				if (data.message)
				{
					winkelwagen_error(data.message);
				}
                if (data.reset)
                {
                    window.location.href = window.location.href;
                }
			}
		}, 'json');

	});
	
	$('#coupon-form').validate({
			submitHandler: function(form) {
			var cart_data = $(form).serializeArray();
			$.post(window.base_url + 'cart.korting.php', cart_data, function(data) {
					if (data.success)
					{
						update_carttotal(data.cart);
                        if (data.validate_data) {
                            $('#coupon-form .collapse').addClass('in');
                        } else {
                            $('#coupon-form .collapse').removeClass('in');
                        }
					} else
					{
                        if (data.validate_data) {
                            $('#coupon-form .collapse').addClass('in');
                        } else {
                            $('#coupon-form .collapse').removeClass('in');
                        }
						if (data.message)
						{
							winkelwagen_error(data.message);
						}
					}				
			}, 'json');
		}
	});
	
	/* BESTELLEN LOGIN */
	$('#cart-login-submit').click(function(e) {
		e.preventDefault();
		$('#cart-login-form').prop('action', window.base_url + 'account-login.php');
		$('#cart-login-form input[name=wachtwoord]').addClass('required');
		$('#cart-login-form').submit();
	});

	$('#cart-login-password').click(function(e) {
		e.preventDefault();
		$('#cart-login-form').prop('action', window.base_url + 'account-wachtwoord.php');
		$('#cart-login-form input[name=wachtwoord]').removeClass('required');
		$('#cart-login-form').submit();
	});

	$('#cart-login-form').validate({
		submitHandler: function(form) {
			$.post($(form).prop('action'), $(form).serializeArray(), function(data) {
					if (data.success)
					{
						if (data.message)
						{
							account_succes(data.message);
						} else
						{
							window.location.href = window.base_url + 'bestellen/gegevens';
						}
					} else
					{
						if (data.message)
						{
							account_error(data.message);
						}
					}				
			}, 'json');
		}
	});
	
	/* BESTELLEN GEGEVENS */
	$('.bestellen.gegevens .bestellen.overzicht').each(function(e) {
		$(this).width($(this).width());
		$(this).css('position', 'fixed');
	});
	if ($('#btw_nummer').length > 0) {
        if ($('#btw_nummer').val().length > 0) {
            var params = [];
            params.push({name: 'btw_land', value: $('#btw-land').html()});
            params.push({name: 'btw_nummer', value: $('#btw_nummer').val()});
            $.post(window.base_url + 'lists/btw', params, function (data) {
                if (data == 'true') {
                    $('#btw_nummer').parent().addClass('valid');
                    $('#btw_nummer').parent().addClass('checked');
                    $('#btw_nummer').parent().parent().parent().removeClass('has-error');
                } else if (data == 'false') {
                    $('#btw_nummer').parent().removeClass('valid');
                    $('#btw_nummer').parent().removeClass('checked');
                    $('#btw_nummer').parent().parent().parent().addClass('has-error');
                } else if (data == 'issue') {
                	// type 2
					$('#btw_nummer').parent().removeClass('valid');
					$('#btw_nummer').parent().removeClass('checked');
					$('#btw_nummer').parent().parent().parent().addClass('has-error');
					messagebox(BootstrapDialog.TYPE_DANGER, 'BTW-nummer controle', 'Sorry, het controleren van BTW-nummers blijkt momenteel niet mogelijk. We helpen u graag persoonlijk verder!<br><br><a href="https://www.kloegcom.nl/contact">Neem contact op met onze klantenservice</a>.');
				}
            });
        }
        ;
    }


    $(window).on('scroll resize', function() {
    	//console.log($('.bestellen.gegevens .bestellen.overzicht').offset().top + $('.bestellen.gegevens .bestellen.overzicht').height());
        //console.log($('footer').offset().top);
        //console.log($(window).scrollTop());

        /*if (($('.bestellen.gegevens .bestellen.overzicht').offset().top + $('.bestellen.gegevens .bestellen.overzicht').height()) > $('footer').offset().top + 100)
            $('.bestellen.gegevens .bestellen.overzicht').css('bottom', $('footer').height() + 15);
        else
            $('.bestellen.gegevens .bestellen.overzicht').css('bottom', 'auto');*/
        if (($(window).scrollTop() + $('.bestellen.gegevens .bestellen.overzicht').height()) > $('.bestellen.gegevens .col-xs-12.col-md-9').height() )
        	$('.bestellen.gegevens .bestellen.overzicht').css('margin-top', $('.bestellen.gegevens .col-xs-12.col-md-9').height() - $('.bestellen.gegevens .bestellen.overzicht').height()).css('position', 'relative');
        else
            $('.bestellen.gegevens .bestellen.overzicht').css('position', 'fixed').css('margin-top', 0);
    });



    //if ($('#postnl-map').length > 0) init_map();
	$('#type_klant').change(function(e) {
		if ($(this).val() == 'zakelijk')
		{
			$('#cart-input-form .zakelijk').removeClass('hidden');
			if ($('#land').val() != 'nl')
			{
				$('#btw-info').removeClass('hidden');
			}
		}
		else
		{
			$('#cart-input-form .zakelijk').addClass('hidden');
			$('#btw-info').addClass('hidden');
		}
	});	
	$('#btw_nummer').on('keydown', function(e) {
		// Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
             // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
             // Allow: Ctrl+C
            (e.keyCode == 67 && e.ctrlKey === true) ||
             // Allow: Ctrl+V
            (e.keyCode == 86 && e.ctrlKey === true) ||
             // Allow: Ctrl+X
            (e.keyCode == 88 && e.ctrlKey === true) ||
             // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
                 // let it happen, don't do anything
                 return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
           // e.preventDefault();
        }
	});

	$('.close-melding').click(function(e) {
		e.preventDefault();
		$(this).parent().remove();
		$.cookie('kloegcom_melding', 'true', { path: '/'});
	});

	$('.toggle-tag').click(function(e) {
		e.preventDefault();
		$(this).next('.modellen-taglist').toggleClass('in');

	});

	$('#btw_nummer').blur(function() {
		var params = [];
		params.push({name: 'btw_land', value: $('#btw-land').html()});
		params.push({name: 'btw_nummer', value: $('#btw_nummer').val()});
		$.post(window.base_url + 'lists/btw', params, function(data) {
			if (data == 'true')
			{
                $('#btw_nummer').parent().addClass('valid');
                $('#btw_nummer').parent().addClass('checked');
                $('#btw_nummer').parent().parent().parent().removeClass('has-error');
			} else if (data == 'false') {
                $('#btw_nummer').parent().removeClass('valid');
                $('#btw_nummer').parent().removeClass('checked');
                $('#btw_nummer').parent().parent().parent().addClass('has-error');
			} else if (data == 'issue') {
				// type 2
				$('#btw_nummer').parent().removeClass('valid');
				$('#btw_nummer').parent().removeClass('checked');
				$('#btw_nummer').parent().parent().parent().addClass('has-error');
				messagebox(BootstrapDialog.TYPE_DANGER, 'BTW-nummer controle', 'Sorry, het controleren van BTW-nummers blijkt momenteel niet mogelijk. We helpen u graag persoonlijk verder!<br><br><a href="https://www.kloegcom.nl/contact">Neem contact op met onze klantenservice</a>.');
			}
		});
	});
	
	$('#cart-input-afleveradres-n').click(function(e){ 
		$('#cart-input-afleveradres').removeClass('in');
		$('#cart-input-postnladres').removeClass('in');
		$('#bezorgopties').addClass('in');
	});
	
	$('#cart-input-afleveradres-j').click(function(e){ 
		$('#cart-input-afleveradres').addClass('in');
		$('#cart-input-postnladres').removeClass('in');
		$('#bezorgopties').addClass('in');
	});
	
	$('#cart-input-afleveradres-o').click(function(e){
		$('#cart-input-afleveradres').removeClass('in');
		$('#cart-input-postnladres').addClass('in');
		$('#bezorgopties').removeClass('in');
		init_map();
        var postcode = $('#cart-input-form input[name=postnl_ophalen_postcode]').val();

        var params = [];
		params.push({name: 'methode', value: 'ophalen'});
		params.push({name: 'postcode', value: postcode });
		params.push({name: 'land', value: $('#land').val() });

		$.post(window.base_url + 'lists/postnl', params, function(data) {
			if (data.succes)
			{
				map_markers(data.markers);
			} else
			{
				//$('input[name=afleveren]').removeAttr('checked');
				messagebox(BootstrapDialog.TYPE_INFO, 'PostNL ophaal punt', 'Er is geen ophaalpunt beschikbaar in de directe omgeving.');
			}
		}, 'json');

	});
	
	$('#cart-input-form input[name=postcode].postcodeNL, #cart-input-form input[name=aflever_postcode].postcodeNL').blur(function(e) {
		$(this).val($(this).val().replace(' ', ''));
	});

	$('#cart-input-form input[name=postcode], #cart-input-form input[name=huisnummer], #cart-input-form input[name=toevoeging]').blur(function(e) {
        var params = [];
        params.push({name: 'postcode', value: $('#cart-input-form input[name=postcode]').val()});
        params.push({name: 'huisnummer', value: $('#cart-input-form input[name=huisnummer]').val()});
        params.push({name: 'toevoeging', value: $('#cart-input-form input[name=toevoeging]').val()});

    	$.post(window.base_url + 'lists/postcode', params, function(data) {
        if (data.succes)
        {
			$('#cart-input-form input[name=straatnaam]').val(data.adres.street);
			$('#cart-input-form input[name=plaats]').val(data.adres.city);
			//if ($('#cart-input-form input[name=postcode]').val().length == 4) $('#cart-input-form select[name=land]').val('be');
            //if ($('#cart-input-form input[name=postcode]').val().length == 6) $('#cart-input-form select[name=land]').val('nl');
            //$('#cart-input-form select[name=land]').trigger('change');
            $('#cart-input-form input[name=straatnaam]').closest('.form-group').removeClass('hidden');
            $('#cart-input-form input[name=plaats]').closest('.form-group').removeClass('hidden');
            $('#cart-input-form select[name=land]').closest('.form-group').removeClass('hidden');

            if ($('#cart-input-form').validate().check('input[name=postcode]'))
            {
                $('#cart-input-form input[name=postcode]').parent().find('span').hide();
                $('#cart-input-form input[name=postcode]').closest('.form-group').removeClass('has-error');
            }
        } else {
			if ( ($('#cart-input-form select[name=land]').val() != 'nl') && ($('#cart-input-form select[name=land]').val() != 'be') ) {
                $('#cart-input-form input[name=straatnaam]').closest('.form-group').removeClass('hidden');
                $('#cart-input-form input[name=plaats]').closest('.form-group').removeClass('hidden');
                $('#cart-input-form select[name=land]').closest('.form-group').removeClass('hidden');
			}
		}
    	}, 'json');
	});

	$('#cart-input-form button[type=submit]').click(function(e) {
		e.preventDefault();
		$('#cart-input-form input[name=straatnaam]').closest('.form-group').removeClass('hidden');
		$('#cart-input-form input[name=plaats]').closest('.form-group').removeClass('hidden');
		$('#cart-input-form select[name=land]').closest('.form-group').removeClass('hidden');
		$('#cart-input-form input[name=aflever_straatnaam]').closest('.form-group').removeClass('hidden');
		$('#cart-input-form input[name=aflever_plaats]').closest('.form-group').removeClass('hidden');
		$('#cart-input-form select[name=aflever_land]').closest('.form-group').removeClass('hidden');
	});

    $('#cart-input-form input[name=aflever_postcode], #cart-input-form input[name=aflever_huisnummer], #cart-input-form input[name=aflever_toevoeging]').blur(function(e) {
        var params = [];
        params.push({name: 'postcode', value: $('#cart-input-form input[name=aflever_postcode]').val()});
        params.push({name: 'huisnummer', value: $('#cart-input-form input[name=aflever_huisnummer]').val()});
        params.push({name: 'toevoeging', value: $('#cart-input-form input[name=aflever_toevoeging]').val()});

    	$.post(window.base_url + 'lists/postcode', params, function(data) {
			if (data.succes)
			{
				$('#cart-input-form input[name=aflever_straatnaam]').val(data.adres.street);
				$('#cart-input-form input[name=aflever_plaats]').val(data.adres.city);
				//if ($('#cart-input-form input[name=aflever_postcode]').val().length == 4) $('#cart-input-form select[name=aflever_land]').val('be');
				//if ($('#cart-input-form input[name=aflever_postcode]').val().length == 6) $('#cart-input-form select[name=aflever_land]').val('nl');
				$('#cart-input-form input[name=aflever_straatnaam]').closest('.form-group').removeClass('hidden');
				$('#cart-input-form input[name=aflever_plaats]').closest('.form-group').removeClass('hidden');
				$('#cart-input-form select[name=aflever_land]').closest('.form-group').removeClass('hidden');

				if ($('#cart-input-form').validate().check('input[name=aflever_postcode]'))
				{
					$('#cart-input-form input[name=aflever_postcode]').parent().find('span').hide();
					$('#cart-input-form input[name=aflever_postcode]').closest('.form-group').removeClass('has-error');
				}
        	} else {
                if ( ($('#cart-input-form select[name=aflever_land]').val() != 'nl') && ($('#cart-input-form select[name=aflever_land]').val() != 'be') ) {
                    $('#cart-input-form input[name=aflever_straatnaam]').closest('.form-group').removeClass('hidden');
                    $('#cart-input-form input[name=aflever_plaats]').closest('.form-group').removeClass('hidden');
                    $('#cart-input-form select[name=aflever_land]').closest('.form-group').removeClass('hidden');
                }
			}
    	}, 'json');
	});

    $('#cart-input-form input[name=straatnaam], #cart-input-form input[name=plaats], #cart-input-form input[name=aflever_straatnaam], #cart-input-form input[name=aflever_plaats]').keyup(function(e) {
		$(this).prop('owninput', 'self');
	});

	
	$('#cart-input-form input[name=postnl_ophalen_postcode]').blur(function(e) {
		var params = [];
		var postcode = $('#cart-input-form input[name=postnl_ophalen_postcode]').val().replace(' ', '');
		params.push({name: 'methode', value: 'ophalen'});
		params.push({name: 'postcode', value: postcode });
        params.push({name: 'land', value: $('#land').val() });
		$.post(window.base_url + 'lists/postnl', params, function(data) {
			if (data.succes)
			{
				map_markers(data.markers);
			} else
			{
				//$('input[name=afleveren]').removeAttr('checked');
				messagebox(BootstrapDialog.TYPE_INFO, 'PostNL ophaal punt', 'Er is geen ophaalpunt beschikbaar in de directe omgeving.');
			}
		}, 'json');
	});

	$('#europa-zending').click(function(e) {
		e.preventDefault();
		$('#europa-zending-keuze').addClass('hidden');
		$('#europa-zending-optie').removeClass('hidden');
	});

    $('#europa-zending-aflever').click(function(e) {
        e.preventDefault();
        $('#europa-zending-aflever-keuze').addClass('hidden');
        $('#europa-zending-aflever-optie').removeClass('hidden');
    });

    $('#cart-input-bezorgen-zeker').click(function(e) {
        // if selected - add price of 2.99
        if ($(this).prop('checked')) {
            $('#cart-verzendkosten').data('kosten', $('#cart-verzendkosten').data('kosten') + 2.99);
            $('#cart-verzendkosten').html('&euro; ' + prijs($('#cart-verzendkosten').data('kosten')));
            rebuild_prijs();
        } else {
            $('#cart-verzendkosten').data('kosten', $('#cart-verzendkosten').data('kosten') - 2.99);
            $('#cart-verzendkosten').html('&euro; ' + prijs($('#cart-verzendkosten').data('kosten')));
            rebuild_prijs();
        }

    });


	$('input[name=bezorgen]').click(function(e) {
		var params = [];
		var postcode = ($('#cart-input-form input[name=afleveren]:checked').val() == 'anders') ? $('#cart-input-form input[name=aflever_postcode]').val() : $('#cart-input-form input[name=postcode]').val();
		var huisnummer = ($('#cart-input-form input[name=afleveren]:checked').val() == 'anders') ? $('#cart-input-form input[name=aflever_huisnummer]').val() : $('#cart-input-form input[name=huisnummer]').val();

		$('input[name=bezorgen]').removeAttr('checked');

		if ($(this).val() == 'standaard')
		{
			$(this).prop('checked', 'checked');
			$('#bezorgen_gekozen').removeClass('in');
            $('#cart-verzendkosten').data('kosten', 0);
            $('#cart-verzendkosten').html('&euro; 0,00');
            rebuild_prijs();
		}
		if ($(this).val() == 'vandaag')
		{
			$('#bezorgen_gekozen').removeClass('in');
			if ((postcode == '') || (huisnummer == ''))
			{
				messagebox(BootstrapDialog.TYPE_DANGER, 'Adresgegevens ontbreken', 'Om deze optie te selecteren moet u eerst uw postcode en huisnummer invoeren.');
				return false;
			}

			params.push({name: 'methode', value: 'vandaag'});
			params.push({name: 'postcode', value: postcode });
			params.push({name: 'huisnummer', value: huisnummer });
			
			var elm = $(this);
			
			$.post(window.base_url + 'lists/postnl', params, function(data) {
				if (data.succes)
				{
					if (typeof data.dag.sameday != 'undefined')
					{
						elm.prop('checked', 'checked');
						$('#cart-verzendkosten').data('kosten', data.dag.sameday.kosten);
						$('#cart-verzendkosten').html('&euro; ' + prijs_calc(data.dag.sameday.kosten));
						rebuild_prijs();
					}
				} else
				{
					$('input[name=bezorgen]').removeAttr('checked');
					if ((data.reden != 'undefined') && (data.reden.length > 0)) {
                        messagebox(BootstrapDialog.TYPE_INFO, 'Vandaag laten bezorgen', data.reden);
					} else {
                        messagebox(BootstrapDialog.TYPE_INFO, 'Vandaag laten bezorgen', 'Het vandaag al 11:00 uur geweest, helaas is het niet meer mogelijk om uw bestelling vandaag nog te ontvangen. Kies een andere bezorgoptie om door te gaan.');
                    }
				}
			}, 'json');
		}
		if ($(this).val() == 'gekozen')
		{
			if ((postcode == '') || (huisnummer == ''))
			{
				messagebox(BootstrapDialog.TYPE_DANGER, 'Adresgegevens ontbreken', 'Om deze optie te selecteren moet u eerst uw postcode en huisnummer invoeren.');
				return false;
			}
			$(this).prop('checked', 'checked');
			$('#bezorgen_gekozen').addClass('in');
            rebuild_prijs();
		}
	});

	$('#bezorgtijden').change(function(e) {
        $('#cart-verzendkosten').data('kosten', ($('#bezorgtijden option:selected').data('kosten') !== null ) ? $('#bezorgtijden option:selected').data('kosten') : 0);
        $('#cart-verzendkosten').html('&euro; ' + prijs(  ($('#bezorgtijden option:selected').data('kosten') !== null ) ? $('#bezorgtijden option:selected').data('kosten') : 0 ) );
        rebuild_prijs();
	});
	
	$('#cart-input-form select[name=bezorg_datum]').change(function() {
		if ($(this).val() == '') return;
		var params = [];
		var postcode = ($('#cart-input-form input[name=afleveren]:checked').val() == 'anders') ? $('#cart-input-form input[name=aflever_postcode]').val() : $('#cart-input-form input[name=postcode]').val();
		var huisnummer = ($('#cart-input-form input[name=afleveren]:checked').val() == 'anders') ? $('#cart-input-form input[name=aflever_huisnummer]').val() : $('#cart-input-form input[name=huisnummer]').val();

		params.push({name: 'methode', value: 'gekozen'});
		params.push({name: 'postcode', value: postcode });
		params.push({name: 'huisnummer', value: huisnummer });
		params.push({name: 'bezorg_datum', value: $('#cart-input-form select[name=bezorg_datum]').val() });
		
		var elm = $(this);

		$('#bezorgtijden').html('<option value="">Bezorgopties worden gezocht</option>');
		
		$.post(window.base_url + 'lists/postnl', params, function(data) {
			if (data.succes)
			{
				var html = '';
				if (typeof data.dag != 'undefined')
				{
					var dag = data.dag;
					if (typeof dag.daytime != 'undefined')
					{
						var dagmoment = dag.daytime;
						html = html + '<option data-kosten="' + dagmoment.kosten + '" value="' + dagmoment.value + '">Standaard, ' + dagmoment.tijdframe + ((dagmoment.kosten != null) ? ' + &euro; ' + prijs_calc(dagmoment.kosten) : '') + '</option>';
					}
					if (typeof dag.morning != 'undefined')
					{
						var dagmoment = dag.morning;
						html = html + '<option  data-kosten="' + dagmoment.kosten + '" value="' + dagmoment.value + '">Ochtend, ' + dagmoment.tijdframe + ((dagmoment.kosten != null) ? ' + &euro; ' + prijs_calc(dagmoment.kosten) : '') + '</option>';
					}
					if (typeof dag.noon != 'undefined')
					{
						var dagmoment = dag.noon;
						html = html + '<option  data-kosten="' + dagmoment.kosten + '" value="' + dagmoment.value + '">' + dagmoment.tijdframe + ((dagmoment.kosten != null) ? ' + &euro; ' + prijs_calc(dagmoment.kosten) : '') + '</option>';
					}
					if (typeof dag.afternoon != 'undefined')
					{
						var dagmoment = dag.afternoon;
						html = html + '<option  data-kosten="' + dagmoment.kosten + '" value="' + dagmoment.value + '">' + dagmoment.tijdframe + ((dagmoment.kosten != null) ? ' + &euro; ' + prijs_calc(dagmoment.kosten) : '') + '</option>';
					}
					if (typeof dag.evening != 'undefined')
					{
						var dagmoment = dag.evening;
						html = html + '<option data-kosten="' + dagmoment.kosten + '" value="' + dagmoment.value + '">Avond, ' + dagmoment.tijdframe + ((dagmoment.kosten != null) ? ' + &euro; ' + prijs_calc(dagmoment.kosten) : '') + '</option>';
					}
					if (typeof dag.sunday != 'undefined')
					{
						var dagmoment = dag.sunday;
						html = html + '<option data-kosten="' + dagmoment.kosten + '" value="' + dagmoment.value + '">Zondag, ' + dagmoment.tijdframe + ((dagmoment.kosten != null) ? ' + &euro; ' + prijs_calc(dagmoment.kosten) : '') + '</option>';
					}
					if (html.length > 0)
						$('#bezorgtijden').html('<option value="">Kies een tijdvak</option>' + html);
					else
						$('#bezorgtijden').html('<option value="">Geen bezorg opties beschikbaar</option>');


				}
                rebuild_prijs();
			} else
			{
				$('input[name=bezorgen]').removeAttr('checked');
				messagebox(BootstrapDialog.TYPE_INFO, 'Bezorgopties', 'Er zijn geen bezorgopties beschikbaar voor de opgegeven postcode/huisnummer.');
				$('#bezorgtijden').html('<option value="">Geen opties op deze datum</option>');
			}				
		}, 'json');

	});


	$('#cart-input-account-maken').click(function(e){ 
		$('#cart-input-account').toggleClass('in');
	});
	
	$('.bestellen #land').change(function(e){
		if ($(this).val() != 'nl')
		{
			$('#afterpay').addClass('hidden');
			if ($('#type_klant').val() == 'zakelijk')
			{
				$('#btw-land').text($(this).val().toUpperCase());
				$('#btw-info').removeClass('hidden');
			}
			/*
			$('.betaal-optie').sort(function (a, b) {
				return $(a).data('bbe') - $(b).data('bbe');
			}).each(function (_, container) {
				$(container).parent().append(container);
			});
			*/
            if ($(this).val() == 'be')
			{
				$('#postcode').addClass('postcodeBE');
                $('#postcode').removeClass('postcodeNL');
            } else {
                $('#postcode').removeClass('postcodeBE');
                $('#postcode').removeClass('postcodeNL');
			}
		}
		if ($(this).val() == 'nl')
		{
			$('#afterpay').removeClass('hidden');
			$('#btw-info').addClass('hidden');
			/*
			$('.betaal-optie').sort(function (a, b) {
				return $(a).data('bnl') - $(b).data('bnl');
			}).each(function (_, container) {
				$(container).parent().append(container);
			});
			*/
            $('#postcode').addClass('postcodeNL');
            $('#postcode').removeClass('postcodeBE');
        }
        $.post(window.base_url + 'cart.save.php', $('#cart-input-form').serializeArray(), function(data) {
			if (data.success) window.location.href = window.location.href;
        }, 'json');
	});

    $('.bestellen #aflever_land').change(function(e){
        if ($(this).val() == 'be')
        {
            $('#aflever_postcode').addClass('postcodeBE');
            $('#aflever_postcode').removeClass('postcodeNL');
        } else if ($(this).val() == 'nl')
        {
            $('#aflever_postcode').addClass('postcodeNL');
            $('#aflever_postcode').removeClass('postcodeBE');
        } else {
            $('#aflever_postcode').removeClass('postcodeNL');
            $('#aflever_postcode').removeClass('postcodeBE');
		}
        $.post(window.base_url + 'cart.save.php', $('#cart-input-form').serializeArray(), function(data) {
            if (data.success) window.location.href = window.location.href;
        }, 'json');
    });

	$('.bestellen #land, .bestellen #aflever_land').change(function(e){
		var prijs = ($('#cart-input-afleveradres-j:checked').length) ? $('#aflever_land option:selected').data('kosten') : $('#land option:selected').data('kosten');
		var afleverland = ($('#cart-input-afleveradres-j:checked').length) ? $('#aflever_land').val() : $('#land').val();
		
		if (afleverland != 'nl')
		{
			$('input[name=bezorgen]').removeAttr('checked');
			$('#bezorgopties').removeClass('in');
		} else
		{
			$('#bezorgopties').addClass('in');		
		}
		
		$('#cart-verzendkosten').html('&euro; ' + prijs_calc(prijs));
		$('#cart-verzendkosten').data('kosten', prijs);
        if ($('#cart-input-form').validate().check('input[name=postcode]'))
        {
            $('#cart-input-form input[name=postcode]').parent().find('span').hide();
            $('#cart-input-form input[name=postcode]').closest('.form-group').removeClass('has-error');
        }
        if ($('#cart-input-form').validate().check('input[name=aflever_postcode]'))
        {
            $('#cart-input-form input[name=aflever_postcode]').parent().find('span').hide();
            $('#cart-input-form input[name=aflever_postcode]').closest('.form-group').removeClass('has-error');
        }
		rebuild_prijs();
	});
	
	$('#cart-input-form input[name=postcode]').blur(function() {
		if ($('#cart-input-form input[name=postnl_ophalen_postcode]').val().length == 0) $('#cart-input-form input[name=postnl_ophalen_postcode]').val($(this).val());
	});
    
	$('#pre-land').change(function(e){
		var prijs = $('#pre-land option:selected').data('kosten');
		if (prijs == 0)
			$('#cart-verzendkosten').addClass('gratisverzenden');
		else
			$('#cart-verzendkosten').removeClass('gratisverzenden');

		$('#cart-verzendkosten').html('&euro; ' + prijs_calc(prijs));
		$('#cart-verzendkosten').data('kosten', prijs);
        var params = new Array();
        params.push({ name: 'preland', value: $('#pre-land option:selected').val()});
        $.post(window.base_url + 'cart.landkeuze.php', params);
		rebuild_prijs();
	});
	
	$('#cart-input-form .betaal-button button[type=submit], #afterpay-input button[type=submit], #billink-input button[type=submit]').click(function(e){
		e.preventDefault();
		$('#cart-input-form .betaal-optie').removeClass('active');
		$(this).closest('.betaal-optie').addClass('active');
		var betaalmethode = $(this).data('betaalmethode');
		$('#cart-input-form select[name=creditcard]').removeClass('required');
		$('#cart-input-form select[name=bank_id]').removeClass('required');
		if (betaalmethode == 'ideal') $('#cart-input-form select[name=bank_id]').addClass('required');
		if (betaalmethode == 'creditcard') $('#cart-input-form select[name=creditcard]').addClass('required');
		$('#cart-input-form input[name=betaalmethode]').val(betaalmethode);
		$('#cart-input-form').submit();
	});
	
	$('#cart-input-form input[name=afleveren]').click(function(e) {
		//console.log($(this).val());
		var afleverland = ($('#cart-input-afleveradres-j:checked').length) ? $('#aflever_land').val() : $('#land').val();
		
		if (afleverland != 'nl')
		{
			$('input[name=bezorgen]').removeAttr('checked');
			$('#bezorgopties').removeClass('in');
		} else
		{
			//$('#bezorgopties').addClass('in');
		}
		if ($('#cart-input-afleveradres-n:checked').length == 0) {
			$('#billink').addClass('hidden');
		} else {
			$('#billink').removeClass('hidden');
		}
		if ($(this).val() == 'ophalen') {
			$('#cart-input-form input[name=bezorgen]').val('standaard');
			$('#cart-input-bezorgen-1').prop('checked', 'checked');
		}
		//$('#');
	});
    $('#cart-input-form button[type="submit"]').on('click', function(e) {
        $(this).addClass('calling').removeClass('hidden');
    });

	$('#cart-input-form').validate({
	    onfocusout: function (element) {
	        if ($(element).valid()) $(element).parent().addClass('valid'); else $(element).parent().removeClass('valid');
	    },
        rules: {
	    	/*
            postcode: {
                minlength: (function() { return ($('#land').val() == 'be') ? 4 : 6 }),
                maxlength: (function() { return ($('#land').val() == 'be') ? 4 : 7 })
            },
            aflever_postcode: {
                minlength: (function() { return ($('#aflever_land').val() == 'be') ? 4 : 6 }), 
                maxlength: (function() { return ($('#aflever_land').val() == 'be') ? 4 : 7 })
            },
			*/
			vatbtw_nummer: {
      			required: true,
      			digits: true,
      			remote: {
					url: window.base_url + 'lists/btw',
					type: "post",
					data: {
						btw_land: function() {
						  return $( "#btw-land" ).html();
						},
						btw_nummer: function() {
						  return $( "#btw_nummer" ).val();
						}
					}
					/*,
success: function (data) { //returns 1 if user exists
                if (data.succes) {
                   console.log("true!");
                   return true;
                } else {
                   console.log("false!");
                   return false;
                }
            }*/
				}
      		}
        },
        messages: {
            postcode: 'Deze postcode is onjuist voor het gekozen land',
            aflever_postcode: 'Deze postcode is onjuist voor het gekozen land',
		  btw_nummer: 'Dit BTW nummer bevat mogelijk fouten'
        },
		submitHandler: function(form) {
            console.log(form);
            console.log($(this));

            if ($('#cart-input-form button[type="submit"]').hasClass('hidden'))
            {

            } else {
                $('#cart-input-form button[type="submit"]').addClass('hidden');
                var params = $(form).serializeArray();
                if ($('#cart-input-form input[name=afleveren]:checked').val() == 'ophalen') {
                    if ($('#cart-input-form input[name=postnl_locatie]:checked').length > 0) {
                        var postnl_loc = $('#cart-input-form input[name=postnl_locatie]:checked').data('marker');
                        params.push({name: 'postnl_ophalen_locationcode', value: postnl_loc.LocationCode});
                        params.push({name: 'postnl_ophalen_retailnetworkid', value: postnl_loc.RetailNetworkID});
                        params.push({name: 'ophalen_bedrijfsnaam', value: postnl_loc.Name});
                        params.push({name: 'ophalen_straatnaam', value: postnl_loc.Address.Street});
                        params.push({name: 'ophalen_huisnummer', value: postnl_loc.Address.HouseNr});
                        params.push({name: 'ophalen_postcode', value: postnl_loc.Address.Zipcode});
                        params.push({name: 'ophalen_plaats', value: postnl_loc.Address.City});
                        params.push({name: 'ophalen_land', value: postnl_loc.Address.Countrcode});
                    } else if ($('#cart-input-form input[name=postnl_ophalen_locationcode]').length > 0) {
                        params.push({
                            name: 'postnl_ophalen_locationcode',
                            value: $('#cart-input-form input[name=postnl_ophalen_locationcode]').val()
                        });
                        params.push({
                            name: 'postnl_ophalen_retailnetworkid',
                            value: $('#cart-input-form input[name=postnl_ophalen_retailnetworkid]').val()
                        });
                    } else {
                        alert('Er is geen PostNL locatie gekozen');
                    }
                }
                $.post(window.base_url + 'cart.save.php', params, function (data) {
                    if (data.success) {
                        document.location = window.base_url + 'cart.betalen.php'; // 'bestellen/controle'; // 
                    } else {
                        winkelwagen_error(data.message);
                        $('#cart-input-form button[type="submit"]').removeClass('hidden').removeClass('calling');
                    }
                }, 'json');
            }
		}

	});
	
	$('.postnl-ophalen-aanpassen').click(function(e){
		e.preventDefault();
		$('#cart-input-afleveradres-o').trigger('click');
	});

	$('#cart-input-form input[name=email]').blur(function(e) {
		if ($(this).valid() === true)
		{
			$.post(window.base_url + 'cart.save.php', $('#cart-input-form').serializeArray());
		}
	});
	
	$('#cart-input-form input[name=nieuwsbrief]').change(function(e) {
		if ($('#cart-input-form input[name=email]').valid() === true)
		{
			$.post(window.base_url + 'cart.save.php', $('#cart-input-form').serializeArray());
		}
	});

	$('#cart-input-form input[name=telefoon]').on('keyup', function() {
		$('#cart-input-form input[name=telefoon2]').val($(this).val());
	});
	$('#cart-input-form input[name=telefoon2]').on('keyup', function() {
		$('#cart-input-form input[name=telefoon]').val($(this).val());
	});
	
	$('#prefill').change(function(e) {
		var cart_data = [];
		cart_data.push({name: 'code', value: $(this).val() });
		$.post(window.base_url + 'cart.prefill.php', cart_data, function(data) {
			if (data.success)
			{
				window.location.href = window.location.href;
			} else
			{
				if (data.message)
				{
					winkelwagen_error(data.message);
				}
			}
		}, 'json');
	});
	
	if (typeof field_errors != 'undefined')
	{
		$.each(field_errors, function(key, fieldname) {
			$(fieldname.value).closest('.form-group').addClass('has-error');
		});
	}
	
	$('#cart-control-submit').click(function(e) { 
		e.preventDefault();
		if ($(this).hasClass('calling'))
		{
		
		} else
		{
			$(this).addClass('calling');
			//setTimeout(function() { $('#cart-control-submit').removeClass('calling');}, 10000);
			$.post(window.base_url + 'cart.betalen.php', function(data) {
				if (typeof fbq != 'undefined') {
					fbq('track', 'InitiateCheckout');
				}
				$(this).removeClass('calling');
				if (data.success)
				{
					window.location.href = data.url;
				} else
				{
					if (data.message)
					{
						betalen_error(data.message, data.url);
					} else {
						window.location.href = data.url;
					}
				}
			}, 'json');
		}		
	});
	
	/*  ACCOUNT - LOGIN */
	$('#account-login-submit').click(function(e) {
		e.preventDefault();
		$('#account-login-form').prop('action', window.base_url + 'account-login.php');
		$('#account-login-form input[name=wachtwoord]').addClass('required');
		$('#account-login-form').submit();
	});

	$('#account-login-password').click(function(e) {
		e.preventDefault();
		$('#account-login-form').prop('action', window.base_url + 'account-wachtwoord.php');
		$('#account-login-form input[name=wachtwoord]').removeClass('required');
		$('#account-login-form').submit();
	});

	$('#account-login-form').validate({
		submitHandler: function(form) {
			$.post($(form).prop('action'), $(form).serializeArray(), function(data) {
					if (data.success)
					{
						if (data.message)
						{
							account_succes(data.message);
						} else
						{
							window.location.href = window.location.href;
						}
					} else
					{
						if (data.message)
						{
							account_error(data.message);
						}
					}				
			}, 'json');
		}
	});

	$('#account-orderstatus-submit').click(function(e) {
		e.preventDefault();
		$('#account-orderstatus-form').submit();
	});

	$('#account-orderstatus-form').validate({
		submitHandler: function(form) {
			$.post(window.base_url + 'order.poll.php', $(form).serializeArray(), function(data) {
					if (data.success)
					{
						messagebox(BootstrapDialog.TYPE_SUCCESS, data.titel, data.message);
					} else
					{
						messagebox(BootstrapDialog.TYPE_DANGER, data.titel, data.message);
					}				
			}, 'json');
		}
	});

	$('#account-orderretour-submit').click(function(e) {
		e.preventDefault();
		$('#account-orderretour-form').submit();
	});

	$('#account-orderretour-form').validate({
		submitHandler: function(form) {
			$.post(window.base_url + 'order.retour.php', $(form).serializeArray(), function(data) {
					if (data.success)
					{
						window.location.href = data.url;
					} else
					{
						messagebox(BootstrapDialog.TYPE_DANGER, data.titel, data.message);
					}
			}, 'json');
		}
	});

	$('#account-create-submit').click(function(e) {
		e.preventDefault();
		$('#account-create-form').submit();
	});

	$('#account-create-form').validate({
		submitHandler: function(form) {
			$.post(window.base_url + 'account-save.php', $(form).serializeArray(), function(data) {
					if (data.success)
					{
						messagebox(BootstrapDialog.TYPE_SUCCESS, 'Mijn KloegCom', data.message, 'Verder', 'account');
					} else
					{
						messagebox(BootstrapDialog.TYPE_DANGER, 'Mijn KloegCom', data.message);
					}				
			}, 'json');
		}
	});
	/* ACCOUNT OVERVIEW */
	$('#account-edit-afleveradres-n').click(function(e){ 
		$('#account-edit-afleveradres').removeClass('in');
	});
	
	$('#account-edit-afleveradres-j').click(function(e){ 
		$('#account-edit-afleveradres').addClass('in');
	});
	
	$('#account-edit-bedrijf-select').click(function(e){ 
		$('#account-edit-bedrijf').toggleClass('in');
	});

	$('#account-edit-adres, #account-edit-contact, #account-edit-login').click(function(e){
		e.preventDefault();
		$('#account-edit').addClass('in');
		$(window).scrollTop($('#anchor' + $(this).prop('id').replace('account-edit', '')).offset().top);
	});
	
	$('#account-edit-submit').click(function(e) {
		e.preventDefault();
		$('#account-edit-form').submit();
	});

	$('#account-edit-form').validate({
		submitHandler: function(form) {
			$.post(window.base_url + 'account-save.php', $(form).serializeArray(), function(data) {
					if (data.success)
					{
						messagebox(BootstrapDialog.TYPE_SUCCESS, 'Mijn KloegCom', data.message, 'Verder', 'account');
					} else
					{
						messagebox(BootstrapDialog.TYPE_DANGER, 'Mijn KloegCom', data.message);
					}				
			}, 'json');
		}
	});


	$(document).on('click', '.postnl-ophalen', function(e) {
		e.preventDefault();
		var loc = $(this).data('ref');
		$('input[name=postnl_locatie].' + loc).trigger('click');	
		var top = $('input[name=postnl_locatie].' + loc).offset().top - 80;
		$('body, html').animate({ scrollTop: top + 'px' });

	});

	$(document).on('click', '.postnl-meerinfo', function(e) {
		e.preventDefault();
		var loc = $(this).data('ref');
		var top = $('input[name=postnl_locatie].' + loc).offset().top - 80;
		$('body, html').animate({ scrollTop: top + 'px' });

	});
	
	$(document).on('click', '#ophalen-kaart', function(e) {
		var top = $('#postnl-map').offset().top - 80;
		$('body, html').animate({ scrollTop: top + 'px' });	
	});

	if (typeof WURFL != 'undefined')
	{
		$.cookie('kloegcom_wurfl', JSON.stringify(WURFL), {expires: 1000, path: '/'});
	}
	

/*
	$('.list-group-toggle-basics').click(function(e) {
		e.preventDefault();
		$(this).next('.list-group').toggleClass('in');
	});
*/

    // RMA
    $('.rma-line-toggle').change(function(e) {
       if (parseInt($(this).val()) > 0) {
           $('#rma-key-' + $(this).data('rma')).val($(this).data('rma'));
           $('#rma-' + $(this).data('rma')).addClass('in');
       } else {
           $('#rma-' + $(this).data('rma')).removeClass('in');
           $('#rma-key-' + $(this).data('rma')).val('');
       }
       if ($('.retour-reden.in').length > 0) {
           $('#rma-submit').addClass('in');
       } else {
           $('#rma-submit').removeClass('in');
       }
    });

    $('select[name^=reden-]').change(function(e){
    	if ($(this).find('option:selected').data('popup') == 'ja') {
			messagebox(BootstrapDialog.TYPE_INFO, 'Uw retour aanvraag', 'Neemt u alstublieft contact op met onze klantenservice. Wij zouden u graag persoonlijk verder helpen.', 'Naar klantenservice', 'https://www.kloegcom.nl/contact');
			$(this).val('');
		}
	});

    $('#retour-form').validate({
        submitHandler: function (form) {
        	$(form).find('button[type=submit]').prop('disabled', true);
            var rma_data = $(form).serializeArray();
            $.post(window.base_url + 'order.rma.php', rma_data, function (data) {
                if (data.success) {
                    messagebox(BootstrapDialog.TYPE_SUCCESS, 'Retouraanvraag ontvangen', 'Wij nemen uw retouraanvraag direct in behandeling. Op werkdagen ontvangt u veelal nog dezelfde dag een e-mail met retourinstructies.', 'Verder', 'retour');
                } else {
                	messagebox(BootstrapDialog.TYPE_DANGER, 'Helaas', 'Het is niet gelukt uw retour te verwerken.');
				}
				$(form).find('button[type=submit]').prop('disabled', false);

            }, 'json');
        }
    });

    $('#shortlist').click(function(e) {
    	e.preventDefault();
        if ($('#product-cart-id option:selected').prop('value').length == 0) {
        	messagebox(BootstrapDialog.TYPE_INFO, 'Verlanglijstje', 'Kies een kleur die op dit moment leverbaar is.');
        	return;
        }
        var shortlist = [];
        shortlist.push( { name: 'prod_id', value: $('#product-cart-id option:selected').prop('value') } )
        $.post(window.base_url + 'shortlist.add.php', shortlist, function(data) {
            if (data.success)
            {
                messagebox(BootstrapDialog.TYPE_SUCCESS, 'Verlanglijstje', data.message, 'Mijn KloegCom', 'account#verlanglijstje');
            } else
            {
                messagebox(BootstrapDialog.TYPE_WARNING, 'Verlanglijstje', data.message, 'Verlanglijstje', 'account#verlanglijstje');
            }
        }, 'json');

	});

    $('.shortlist-delete').click(function(e) {
        e.preventDefault();
        var $line = $(this).closest('.line');
        var line = $(this).closest('.line').data('shortlist-code');
        var cart_data = [];
        cart_data.push({name: 'line', value: line});
        $.post(window.base_url + 'shortlist.delete.php', cart_data, function(data) {
            if (data.success)
            {
                $line.remove();
                if ($('#verlanglijstje .line').length == 0) $('#shortlist-empty').removeClass('hidden');
            } else
            {
                messagebox(BootstrapDialog.TYPE_DANGER, 'Verlanglijstje', 'Product kon niet worden verwijderd');
            }
        }, 'json');

    });

    $('#shortlist-send-form').validate({
        submitHandler: function (form) {
            var shortlist = $(form).serializeArray();
            $.post(window.base_url + 'shortlist.send.php', shortlist, function (data) {
                if (data.success) {
                    $(form)[0].reset();
                    messagebox(BootstrapDialog.TYPE_SUCCESS, 'Verlanglijstje', data.message);
                } else {
                    messagebox(BootstrapDialog.TYPE_SUCCESS, 'Verlanglijstje', data.message);
                }

            }, 'json');
        }
    });

    var url = document.location.toString();
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

/*
    if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
        $('#applepay').hide();
    } else {
    	$('#applepay').show();
	}
*/

    $('.toggle-area').click(function(e) {
        e.preventDefault();
        var area = $(this).data('target');
        if ($(this).hasClass('desktop')) {
            $(area).toggleClass('desktop-in');
            $(this).toggleClass('desktop-open');
        } else {
            $(area).toggleClass('in');
            $(this).toggleClass('open');
        }
    });
    $('.smooth-scroll').click(function(e) {
        e.preventDefault();
        var area = $(this).data('scroll');
        $('html, body').animate({
            scrollTop: $(area).offset().top - 100
        }, 500);
    });

    $('#description-more').click(function(e) {
        e.preventDefault();
        $('.description').toggleClass('open');
        $('.description-more').addClass('hidden');
    });
    $('#description-less').click(function(e) {
        e.preventDefault();
        $('.description').toggleClass('open');
        $('.description-more').removeClass('hidden');
        // smooth scroll to description-box
        $('html, body').animate({
            scrollTop: $('.description').offset().top - 100
        }, 500);
    });
});

function winkelwagen_succes()
{
	BootstrapDialog.show({
			title: 'Winkelwagen',
			message: 'Artikel aan winkelwagen toegevoegd',
			type: BootstrapDialog.TYPE_SUCCESS, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
			closable: true, // <-- Default value is false
			buttons: [{
				label: 'Terug',
				action: function(dialog) {
					dialog.close();
				}
			}, {
				label: 'Winkelwagen',
				action: function(dialog) {
					window.location.href = window.base_url + 'bestellen';
				}
			}]
	});	
}

function winkelwagen_error(message)
{
	BootstrapDialog.show({
			title: 'Winkelwagen',
			message: message,
			type: BootstrapDialog.TYPE_DANGER, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
			closable: true, // <-- Default value is false
			buttons: [{
				label: 'Oké',
				action: function(dialog) {
					dialog.close();
				}
			}]
	});	
}

function update_cartline(line)
{
	var $line = $('#cartline-' + line.id);
	$line.find('.line-piece-price').html('Per stuk: &nbsp;&nbsp;&euro; ' + prijs(line.price) + '');
	$line.find('.line-total-price').html('Totaal: &nbsp;&nbsp;&euro; ' + prijs(line.price * line.ammount));
	$line.find('input[name=line_count]').val(line.ammount);
}

function update_carttotal(cart)
{
	$('#cart-subtotal').html('&euro; ' + prijs(cart.prijs));
	if (cart.korting > 0)
	{
		$('#korting-row').removeClass('hidden');
		$('#cart-korting').html('&euro; -' + prijs(cart.korting));
	} else
	{
		$('#korting-row').addClass('hidden');
	}
	$('#cart-verzendkosten').html('&euro; ' + prijs(cart.verzendkosten));
	if ($('#cart-btw').length > 0)
	{
		$('#cart-btw').html('&euro; ' + prijs(cart.btw));
		$('#cart-total').html('&euro; ' + prijs(parseFloat(cart.prijs) + parseFloat(cart.btw) + parseFloat(cart.verzendkosten) - parseFloat(cart.korting)));
	} else
		$('#cart-total').html('&euro; ' + prijs(cart.prijs + cart.verzendkosten - cart.korting));
}

function prijs(val)
{
	return parseFloat(val).toFixed(2).toString().replace('.', ',');
}

function account_succes(message)
{
	BootstrapDialog.show({
			title: 'Mijn KloegCom',
			message: message,
			type: BootstrapDialog.TYPE_SUCCESS, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
			closable: true, // <-- Default value is false
			buttons: [{
				label: 'Oké',
				action: function(dialog) {
					dialog.close();
				}
			}]
	});	
}

function account_error(message)
{
	BootstrapDialog.show({
			title: 'Mijn KloegCom',
			message: message,
			type: BootstrapDialog.TYPE_DANGER, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
			closable: true, // <-- Default value is false
			buttons: [{
				label: 'Oké',
				action: function(dialog) {
					dialog.close();
				}
			}]
	});	
}


function betalen_error(message, url)
{
	BootstrapDialog.show({
			title: 'Bestelling afronden',
			message: message,
			type: BootstrapDialog.TYPE_DANGER, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
			closable: true, // <-- Default value is false
			buttons: [{
				label: 'Verder',
				action: function(dialog) {
					dialog.close();
					window.location.href = window.base_url + url;
				}
			}]
	});	
}

function messagebox(msgtype, title, message, button, url)
{
	if (typeof button == 'undefined') button = 'Oké'; 
	BootstrapDialog.show({
			title: title,
			message: message,
			type: msgtype, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
			closable: true, // <-- Default value is false
			buttons: [{
				label: button,
				action: function(dialog) {
					dialog.close();
					if (typeof url != 'undefined') window.location.href = window.base_url + url;
				}
			}]
	});	
}

function prijs_calc(val)
{
	return parseFloat(val).toFixed(2).toString().replace('.', ',');
	
}

function rebuild_prijs()
{
	if ($('#cart-btw').length > 0)
		var prijs = parseFloat($('#cart-subtotal').data('kosten')) - parseFloat($('#cart-korting').data('kosten')) + parseFloat($('#cart-btw').data('kosten')) + parseFloat($('#cart-verzendkosten').data('kosten'));
	else
		var prijs = parseFloat($('#cart-subtotal').data('kosten')) - parseFloat($('#cart-korting').data('kosten')) + parseFloat($('#cart-verzendkosten').data('kosten'));
	$('#cart-total').html('&euro; ' + prijs_calc(prijs));
}

function init_map()
{
	$("#postnl-map").gmap3({
		map:{
			address: 'Nederland',
			options:{
				mapTypeId: google.maps.MapTypeId.ROAD,
				zoom: 7
			}
		},
		marker: {
			address: 'Nederland'
		}
	});
	
	$(document).on('click', 'input[name=postnl_locatie]', function(e) {
	});
	
	$("#postnl-locaties").popover({
		selector: '.open-pop',
		trigger: 'click',
		html : true, 
		content: function() {
			return '<table class="postnl-opentijden">' + $(this).parent().find('table').html() + '</table>';
		},
		title: 'Openingstijden <button type="button" class="pull-right popover-hide">&times;</button>'
		
	});	
	$(document).on('click', "#postnl-locaties .open-pop, .popover-hide", function(e) {
		$('#postnl-locaties .open-pop').not(this).popover('hide');
	
	});
}

function map_markers(markers)
{
	var postcode = $('#cart-input-form input[name=postnl_ophalen_postcode]').val();
	$('#postnl-locaties div').remove();
	$.each(markers, function(key, marker) {
		var $postnl_optie = $('#postnl-locatie-clone div').clone();
		$postnl_optie.prepend('<img src="' + marker.options.icon + '"> ');
		$postnl_optie.find('label').append('' + marker.data.Name + ' <span>' + marker.data.Address.Street + ' ' + marker.data.Address.HouseNr + ', ' + marker.data.Address.Zipcode + ' ' + marker.data.Address.City + '</span>');
		$postnl_optie.find('.open-maandag').html((typeof marker.data.OpeningHours.Monday != 'undefined') ? marker.data.OpeningHours.Monday.string : 'gesloten'); 
		$postnl_optie.find('.open-dinsdag').html((typeof marker.data.OpeningHours.Tuesday != 'undefined') ? marker.data.OpeningHours.Tuesday.string : 'gesloten'); 
		$postnl_optie.find('.open-woensdag').html((typeof marker.data.OpeningHours.Wednesday != 'undefined') ? marker.data.OpeningHours.Wednesday.string : 'gesloten'); 
		$postnl_optie.find('.open-donderdag').html((typeof marker.data.OpeningHours.Thursday != 'undefined') ? marker.data.OpeningHours.Thursday.string : 'gesloten'); 
		$postnl_optie.find('.open-vrijdag').html((typeof marker.data.OpeningHours.Friday != 'undefined') ? marker.data.OpeningHours.Friday.string : 'gesloten'); 
		$postnl_optie.find('.open-zaterdag').html((typeof marker.data.OpeningHours.Saturday != 'undefined') ? marker.data.OpeningHours.Saturday.string : 'gesloten');
		$postnl_optie.find('.open-zondag').html((typeof marker.data.OpeningHours.Sunday != 'undefined') ? marker.data.OpeningHours.Sunday.string : 'gesloten'); 
 		$postnl_optie.find('input').val(marker.data.LocationCode + '#' + marker.data.RetailNetworkID);
 		$postnl_optie.find('input').addClass(marker.data.id);
 		$postnl_optie.find('input').data('marker', marker.data);
 		$postnl_optie.append('<span class="open-pop"><i class="fa fa-clock-o"></i> openingstijden</span>');
		$('#postnl-locaties').append($postnl_optie);
	});
	
	$("#postnl-map").gmap3({
		getlatlng:{
			address: postcode,
			callback: function(results){
				if ( !results ) return;
				$("#postnl-map").gmap3('get').panTo(results[0].geometry.location);
				$("#postnl-map").gmap3('get').setZoom(13);
				$("#postnl-map").gmap3({
					clear: {
						name:["marker"]
					}
				});
				$("#postnl-map").gmap3({
					marker: {
						values: markers,
						events:{
							click: function(marker, event, context){
								if( currentMarker )
								{
									currentMarker.setOptions({
										icon: currentMarker.icon.replace('Pin','Circle')
									});
								}                         
								
								marker.setOptions({
									icon : marker.icon.replace('Circle','Pin')
								});
                           
                          			currentMarker = marker;
					 			var info = '';
								info = '<p>';
								info = info + '<b>' + context.data.Name + '</b><br>';
								info = info + context.data.Address.Street + ' ' + context.data.Address.HouseNr + '<br>';
								info = info + context.data.Address.Zipcode + ' ' + context.data.Address.City + '</p>';
								info = info + '<p><a href="javascript: postnl_meerinfo(\'' + context.data.id + '\'); void(0);" class="postnl-meerinfo btn btn-grey" data-ref="' + context.data.id + '">Meer info</a> <a href="javascript: postnl_ophalen(\'' + context.data.id + '\'); void(0);" class="postnl-ophalen btn btn-blue" data-ref="' + context.data.id + '">Hier ophalen</a></p>';
								marker.data = context.data;
								$(this).gmap3({clear:"infowindow"}, {
									infowindow:{
										latLng: marker.getPosition(),
										options:{
											content:  "<div class='infobox'>" + info +
												"</div>"
										}
									}
								});
								$("#postnl-map").gmap3('get').panTo(marker.getPosition());
								$("#postnl-map").gmap3('get').setZoom(14);
							}
						},
						callback: function(results){
							$("#postnl-map").gmap3('autofit');
						}
					}
				});
			}
		}
	});
}

function postnl_ophalen(loc)
{
	$('input[name=postnl_locatie].' + loc).trigger('click');	
}

function postnl_meerinfo(loc)
{
	var top = $('input[name=postnl_locatie].' + loc).offset().top;
	$('body, html').animate({ scrollTop: top + 'px' });
}

var currentMarker = false;



function accepting_cookie()
{
	if ($('#cookie-bar').length > 0)
	{
		$('#cookie-bar').remove();
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
		(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
		m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
		
		ga('create', 'UA-20177349-5', 'auto');
		ga('require', 'ec');
		setTimeout("ga('send', 'event', '45_seconds', 'read');",45000);
		ga('send', 'pageview');

		!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
			n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
			n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
			t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
			document,'script','https://connect.facebook.net/en_US/fbevents.js');
		fbq('init', '670489343092582'); // Insert your pixel ID here.
		fbq('track', 'PageView');

	}	
	$.cookie('kloegcom_cookies', 'true', {expires: 1000, path: '/'});
}

	var $document = $( document ),
		supportTouch = true,
		scrollEvent = "touchmove scroll",
		touchStartEvent = supportTouch ? "touchstart" : "mousedown",
		touchStopEvent = supportTouch ? "touchend" : "mouseup",
		touchMoveEvent = supportTouch ? "touchmove" : "mousemove";
		
	$.each( ( "touchstart touchmove touchend " +
		"tap taphold " +
		"swipe swipeleft swiperight " +
		"scrollstart scrollstop" ).split( " " ), function( i, name ) {

		$.fn[ name ] = function( fn ) {
			return fn ? this.bind( name, fn ) : this.trigger( name );
		};

		// jQuery < 1.8
		if ( $.attrFn ) {
			$.attrFn[ name ] = true;
		}
	});
	
	
		// Also handles swipeleft, swiperight
	$.event.special.swipe = {

		// More than this horizontal displacement, and we will suppress scrolling.
		scrollSupressionThreshold: 30,

		// More time than this, and it isn't a swipe.
		durationThreshold: 1000,

		// Swipe horizontal displacement must be more than this.
		horizontalDistanceThreshold: 30,

		// Swipe vertical displacement must be less than this.
		verticalDistanceThreshold: 30,

		getLocation: function ( event ) {
			var winPageX = window.pageXOffset,
				winPageY = window.pageYOffset,
				x = event.clientX,
				y = event.clientY;

			if ( event.pageY === 0 && Math.floor( y ) > Math.floor( event.pageY ) ||
				event.pageX === 0 && Math.floor( x ) > Math.floor( event.pageX ) ) {

				// iOS4 clientX/clientY have the value that should have been
				// in pageX/pageY. While pageX/page/ have the value 0
				x = x - winPageX;
				y = y - winPageY;
			} else if ( y < ( event.pageY - winPageY) || x < ( event.pageX - winPageX ) ) {

				// Some Android browsers have totally bogus values for clientX/Y
				// when scrolling/zooming a page. Detectable since clientX/clientY
				// should never be smaller than pageX/pageY minus page scroll
				x = event.pageX - winPageX;
				y = event.pageY - winPageY;
			}

			return {
				x: x,
				y: y
			};
		},

		start: function( event ) {
			var data = event.originalEvent.touches ?
					event.originalEvent.touches[ 0 ] : event,
				location = $.event.special.swipe.getLocation( data );
			return {
						time: ( new Date() ).getTime(),
						coords: [ location.x, location.y ],
						origin: $( event.target )
					};
		},

		stop: function( event ) {
			var data = event.originalEvent.touches ?
					event.originalEvent.touches[ 0 ] : event,
				location = $.event.special.swipe.getLocation( data );
			return {
						time: ( new Date() ).getTime(),
						coords: [ location.x, location.y ]
					};
		},

		handleSwipe: function( start, stop, thisObject, origTarget ) {
			if ( stop.time - start.time < $.event.special.swipe.durationThreshold &&
				Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.horizontalDistanceThreshold &&
				Math.abs( start.coords[ 1 ] - stop.coords[ 1 ] ) < $.event.special.swipe.verticalDistanceThreshold ) {
				var direction = start.coords[0] > stop.coords[ 0 ] ? "swipeleft" : "swiperight";

				triggerCustomEvent( thisObject, "swipe", $.Event( "swipe", { target: origTarget, swipestart: start, swipestop: stop }), true );
				triggerCustomEvent( thisObject, direction,$.Event( direction, { target: origTarget, swipestart: start, swipestop: stop } ), true );
				return true;
			}
			return false;

		},

		// This serves as a flag to ensure that at most one swipe event event is
		// in work at any given time
		eventInProgress: false,

		setup: function() {
			var events,
				thisObject = this,
				$this = $( thisObject ),
				context = {};

			// Retrieve the events data for this element and add the swipe context
			events = $.data( this, "mobile-events" );
			if ( !events ) {
				events = { length: 0 };
				$.data( this, "mobile-events", events );
			}
			events.length++;
			events.swipe = context;

			context.start = function( event ) {

				// Bail if we're already working on a swipe event
				if ( $.event.special.swipe.eventInProgress ) {
					return;
				}
				$.event.special.swipe.eventInProgress = true;

				var stop,
					start = $.event.special.swipe.start( event ),
					origTarget = event.target,
					emitted = false;

				context.move = function( event ) {
					if ( !start || event.isDefaultPrevented() ) {
						return;
					}

					stop = $.event.special.swipe.stop( event );
					if ( !emitted ) {
						emitted = $.event.special.swipe.handleSwipe( start, stop, thisObject, origTarget );
						if ( emitted ) {

							// Reset the context to make way for the next swipe event
							$.event.special.swipe.eventInProgress = false;
						}
					}
					// prevent scrolling
					if ( Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.scrollSupressionThreshold ) {
						event.preventDefault();
					}
				};

				context.stop = function() {
						emitted = true;

						// Reset the context to make way for the next swipe event
						$.event.special.swipe.eventInProgress = false;
						$document.off( touchMoveEvent, context.move );
						context.move = null;
				};

				$document.on( touchMoveEvent, context.move )
					.one( touchStopEvent, context.stop );
			};
			$this.on( touchStartEvent, context.start );
		},

		teardown: function() {
			var events, context;

			events = $.data( this, "mobile-events" );
			if ( events ) {
				context = events.swipe;
				delete events.swipe;
				events.length--;
				if ( events.length === 0 ) {
					$.removeData( this, "mobile-events" );
				}
			}

			if ( context ) {
				if ( context.start ) {
					$( this ).off( touchStartEvent, context.start );
				}
				if ( context.move ) {
					$document.off( touchMoveEvent, context.move );
				}
				if ( context.stop ) {
					$document.off( touchStopEvent, context.stop );
				}
			}
		}
	};
	$.each({
		scrollstop: "scrollstart",
		taphold: "tap",
		swipeleft: "swipe.left",
		swiperight: "swipe.right"
	}, function( event, sourceEvent ) {

		$.event.special[ event ] = {
			setup: function() {
				$( this ).bind( sourceEvent, $.noop );
			},
			teardown: function() {
				$( this ).unbind( sourceEvent );
			}
		};
	});
	
		function triggerCustomEvent( obj, eventType, event, bubble ) {
		var originalType = event.type;
		event.type = eventType;
		if ( bubble ) {
			$.event.trigger( event, undefined, obj );
		} else {
			$.event.dispatch.call( obj, event );
		}
		event.type = originalType;
	}

function onPrev()
{
    if (_index > 0) {
        setIndex(_index - 1);
        $('#product-foto').flexslider("prev")
    }
}

function onNext()
{
    if (_index < (pzItems.length - 1)) {
        setIndex(_index + 1);
        $('#product-foto').flexslider("next")
    }
}

function setIndex(val) {
	if (val == _index) {
		pz.fullscreen(true);
	}
	else
	{
		_index = val;
		var pzItem = pzItems.eq(_index);
		pz.elem(pzItem, false, false);
	}

	pz.fullscreen(true);
	$(".controlHolder").append(prevButton);
	$(".controlHolder").append(nextButton);

	if(val == 0)
	{
		prevButton.removeClass("on");
		prevButton.addClass("off");
	}
	else
	{
		prevButton.removeClass("off");
		prevButton.addClass("on");
	}

	if(val == pzItems.length - 1)
	{
		nextButton.removeClass("on");
		nextButton.addClass("off");
	}
	else
	{
		nextButton.removeClass("off");
		nextButton.addClass("on");
	}

}

$(window).on('scroll resize', function() {
	var windowTop = $(window).scrollTop();
	if (!$('html').hasClass('touch-menu')) {
		if (windowTop > 50) $('header').addClass('is_stuck'); else $('header').removeClass('is_stuck');
	}
});

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

function change_language()
{
	BootstrapDialog.show({
		title: "Yes, we're shipping to the EU!",
		message: $('#select-language'),
		type: BootstrapDialog.TYPE_SUCCESS, // <-- Default value is BootstrapDialog.TYPE_PRIMARY
		size: BootstrapDialog.SIZE_WIDE,
		closable: true, // <-- Default value is false
		buttons: [{
			label: 'Cancel',
			action: function(dialog) {
				dialog.close();
				$.cookie('kloegcom_langauge', 'false', {expires: 100, path: '/'});
			}
		}, {
			label: 'Save',
			action: function(dialog) {
				var params = []
				params.push({name: 'preland', value: $('#select-shipment-country').val() });
				$.cookie('kloegcom_langauge', $('#select-shipment-country').val(), {expires: 100, path: '/'});
				$.post(window.base_url + 'cart.landkeuze.php', params);
				dialog.close();
			}
		}]
	});
}

if (typeof json_message != 'undefined')
{
    winkelwagen_error(json_message);
}
